import styled from 'styled-components';
export const HeaderAlertStyled = styled.div `
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
`;
export const HeaderContentAlertStyled = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
export const BodyAlertStyled = styled.div `
  padding-left: 60px;
  padding-right: 11px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
export const BodyButtonAlertStyled = styled.div `
  display: flex;
  justify-content: right;
`;
export const ItemAlertStyled = styled.div `
  background: ${({ variant }) => {
    switch (variant) {
        case 'error':
            return 'linear-gradient(130deg, rgb(250, 190, 179, 0.6), rgb(255, 89, 63, 0.6))';
        case 'success':
            return 'linear-gradient(130deg, rgb(210, 238, 155, 0.6), rgb(149, 211, 28, 0.6))';
        default:
            return 'linear-gradient(130deg,rgb(253, 227, 161, 1), rgb(255, 226, 168, 0.4))';
    }
}};
  border: 1px solid
    ${({ variant }) => {
    switch (variant) {
        case 'error':
            return 'rgb(232, 166, 167, 0.4)';
        case 'success':
            return 'rgb(210, 238, 157)';
        default:
            return 'rgb(254, 193, 51, 0.4)';
    }
}};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  box-shadow: -4px -4px 9px 0px rgba(255, 255, 255, 0.6) inset;

  width: max-content;
  height: max-content;
  padding: 6px;
`;
export const AlertStyled = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px 26px 21px 17px;
  border-radius: 14px;
  box-shadow: 4px 4px 20px 0px rgba(111, 140, 176, 0.41), -6px -6px 20px 0px #fff,
    2px 2px 4px 0px rgba(114, 142, 171, 0.1);

  background-color: ${({ variant }) => {
    switch (variant) {
        case 'error':
            return '#FFF2EF';
        case 'success':
            return '#F9FDF1';
        default:
            return '#FFF9E8';
    }
}};

  ${({ theme: { typography } }) => {
    return typography.body3;
}};

  width: ${({ size }) => {
    switch (size) {
        case 'large':
            return '483px';
        case 'medium':
            return '420px';
        default:
            return '322px';
    }
}};

  border: 1px solid
    ${({ variant }) => {
    switch (variant) {
        case 'error':
            return '#FF593F';
        case 'success':
            return '#AEC18C';
        default:
            return '#F7D884';
    }
}};
`;
//# sourceMappingURL=styled.js.map